<template>
	<div>
		<div class="page-filter-box">
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-input v-model="params.searchValue" class="input-with-select" size="small">
						<el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
							<el-option label="演出ID" :value="1"></el-option>
							<el-option label="演出名称" :value="2"></el-option>
							<el-option label="巡演ID" :value="3"></el-option>
						</el-select>
					</el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
					<div class="clearfix timeType">
						<el-input class="input-with-select fl" size="small">
							<el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
								<el-option label="推送时间" :value="1"></el-option>
							</el-select>
						</el-input>
						<el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始日期"
							end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
							:default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
						</el-date-picker>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.thirdPartnerList" placeholder="不限制三方渠道" class="fl fl-big-select" multiple
						clearable size="small">
						<el-option v-for="(item, index) in thirdAccount" :key="index" :label="item.thirdName"
							:value="item.source"></el-option>
					</el-select>
				</el-col>
				<el-col  :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.appletList" placeholder="不限制小程序" class="fl fl-big-select" multiple
						clearable size="small">
						<el-option label="抖音小程序" value="dou_yin"></el-option>
						<el-option label="支付宝小程序" value="ali"></el-option>
						<el-option label="小红书小程序" value="red_booklet"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-cascader v-model="styleType" :options="showTypeTagList"
						:props="{ checkStrictly: true, value: 'id', label: 'name', children: 'tags', emitPath:false }"
						clearable size="small" placeholder="不限制活动类型" style="width:100%" ref="cascader"
						@change="changeStyle">
					</el-cascader>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.activityStatus" placeholder="请选择" size="small">
						<el-option label="不限制演出状态" :value="0"></el-option>
						<el-option label="仅看待审核的" :value="1"></el-option>
						<el-option label="仅看预售中的" :value="2"></el-option>
						<el-option label="仅看已结束的" :value="3"></el-option>
						<el-option label="仅看已取消的" :value="4"></el-option>
						<el-option label="仅看未通过的" :value="5"></el-option>
						<el-option label="仅看定时上架的" :value="6"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.sellIdentity" placeholder="请选择" size="small">
						<el-option label="不限制是否独家" :value="0"></el-option>
						<el-option label="仅看独家的" :value="1"></el-option>
						<el-option label="仅看非独家的" :value="2"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.approval" placeholder="请选择" size="small">
						<el-option label="不限制报批进度" :value="0"></el-option>
						<el-option label="仅看有批文的" :value="1"></el-option>
						<el-option label="仅看报批申请中的" :value="2"></el-option>
						<el-option label="仅看还未申请报批的" :value="3"></el-option>
					</el-select>
				</el-col>				
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.campusAgentStatus" placeholder="请选择" size="small">
						<el-option label="不限制校园代理" value=""></el-option>
						<el-option label="仅看参加校园代理的" :value="1"></el-option>
						<el-option label="仅看不参加校园代理的" :value="0"></el-option>
					</el-select>
				</el-col>
				<!-- 导出内容：数据表/批文默认全选，两项均未勾选时拦截导出；批文仅随三方渠道导出 -->
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-checkbox v-model="exportExcel" border size="small">导出数据表</el-checkbox>
					<el-checkbox v-model="exportApproval" border size="small">导出批文</el-checkbox>
				</el-col>
			</el-row>
		</div>
		<div class="page-btns-box">
			<el-button v-if="$utils.have('/activity/export')" type="primary" icon="el-icon-download" size="small"
				@click="download" :loading="downLoading">导出推送记录</el-button>
			<el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
		</div>

	</div>
</template>

<script>
	import {
		
		fetchThirdAccount
	} from '@/assets/js/commonApi';
	

	const defaultParams = {

		searchType: 1,
		searchValue: '',

		timeType: 1,
		startTime: '',
		endTime: '',

		appletList: [],
		thirdPartnerList: [],
		activityStatus: 2, //演出状态默认预售中（需求 7123492668）
		sellIdentity: 0,
		approval: 0,

		showTypeTagParentId: '',
		showTypeTagId: '',
		campusAgentStatus:''

	}
	export default {
		components: {

		},
		data() {			
			return {
				data: null,
				dataList: null,
				params: {
					...defaultParams,
					searchType: parseInt(this.$route.query.searchType || 1),
					searchValue: this.$route.query.searchValue || '',
					timeType: parseInt(this.$route.query.timeType || 1),
					startTime: this.$route.query.startTime || '',
					endTime: this.$route.query.endTime || '',
					campusAgentStatus: this.$route.query.campusAgentStatus || '',
					sellIdentity: this.$route.query.sellIdentity ? parseInt(this.$route.query.sellIdentity) : 0,
					activityStatus: parseInt(this.$route.query.activityStatus || 2),
					approval: parseInt(this.$route.query.approval || 0) || 0,
				},
				listLoading: true,
				datetimerange: [],
				downLoading: false,
				showTypeTagList: [],
				thirdAccount: [],
				styleType: [],
				// 导出内容勾选：数据表/批文默认全选
				exportExcel: true,
				exportApproval: true
			}
		},
		created() {
		    let startTime = ''
		    let endTime = ''
		    let yy = new Date().getFullYear();
		    let mm = new Date().getMonth() + 1;
		    let dd = new Date().getDate();		    
		    startTime = yy + '-' + mm + '-' + dd + ' ' + '00' + ':' + '00' + ':' + '00';
		    endTime = yy + '-' + mm + '-' + dd + ' ' + '23' + ':' + '59' + ':' + '59';		    
		    this.datetimerange = [startTime, endTime]
		},
		mounted() {
			this.getShowTypeTag();
			this.getThirdAccount();
		},
		methods: {
			//获取活动类型
			getShowTypeTag() {
				this.$request({
					url: "/styleTag/showType/all",
					method: "post",
					params: {
						isAll: 1
					}
				}).then(res => {
					const {
						state,
						result
					} = res.data;
					if (state == 1) {
						this.showTypeTagList = result || []
					}
				})
			},
			changeStyle() {
				var item = this.$refs.cascader.getCheckedNodes()[0].path;
				this.styleType = item
			},
			//获取第三方平台
			getThirdAccount() {
				fetchThirdAccount({
						isThird: 1
					})
					.then((res) => {
						const {
							state,
							result
						} = res.data;
						if (state == 1 && result) {
							this.thirdAccount = result.thirdAccounts || [];
						} else {
							// this.$message.error(msg || "请求失败");
						}
					})
			},
			//重置搜索
			reset() {
				let startTime = ''
				let endTime = ''
				let yy = new Date().getFullYear();
				let mm = new Date().getMonth() + 1;
				let dd = new Date().getDate();		    
				startTime = yy + '-' + mm + '-' + dd + ' ' + '00' + ':' + '00' + ':' + '00';
				endTime = yy + '-' + mm + '-' + dd + ' ' + '23' + ':' + '59' + ':' + '59';		    
				this.datetimerange = [startTime, endTime]
				this.styleType = []
				this.params = {
					...defaultParams,
				};
				// 导出内容勾选恢复默认全选
				this.exportExcel = true;
				this.exportApproval = true;
			},
			//导出（渠道即包：每个渠道独立下载任务，无数据的渠道不生成任务）
			download() {
				// 两项导出内容均未勾选时拦截
				if (!this.exportExcel && !this.exportApproval) {
					return this.$message.error('请至少选择一种导出内容（数据表/批文）');
				}
				this.downLoading = true;
				this.$request({
						url: "/activityPushExport/create",
						method: "POST",
						data: {
							...this.params,
							startTime: this.datetimerange && this.datetimerange[0] || '',
							endTime: this.datetimerange && this.datetimerange[1] || '',
							showTypeTagParentId:this.styleType[0] || '',
							showTypeTagId:this.styleType[1] || '',
							exportExcel: this.exportExcel, // 导出数据表
							exportApproval: this.exportApproval // 导出批文（仅随三方渠道导出）
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1) {
							// result 为本次创建的下载任务数，多任务时提示总数
							const _tip = result > 1 ? `下载任务创建成功（共 ${result} 个）,可以在下载任务列表查看` : '下载任务创建成功,可以在下载任务列表查看';
							this.$confirm(_tip, '提示', {
								confirmButtonText: '立即查看',
								cancelButtonText: '稍后再看',
								type: 'success',
								center: true,
								closeOnClickModal: false
							}).then(() => {
								this.$router.push({
									path: '/workbench/downloadList'
								})
							}).catch(() => {})
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.downLoading = false;
					});
			},

		}
	}
</script>